
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// import { useI18n } from 'vue-i18n'
import router from '@/router'
import { RouteLocationNormalized } from 'vue-router'
import { useStore } from './store'
import { UserActionTypes } from './store/modules/user/action-types'
import { PermissionActionType } from './store/modules/permission/action-types'
import { ElMessage } from 'element-plus'
import {getToken,removeToken} from './utils/cookies'
import whiteList from './config/default/whitelist'
// import settings from '@/config/default/setting.config'
import i18n from "@/locales/index";
const _t = i18n.global.t;
NProgress.configure({ showSpinner: false })

// const getPageTitle = (key: string) => {
//   const i18n = useI18n()
//   const title = settings.title
//   const hasKey = i18n.te(`route.${key}`)
//   if (hasKey) {
//     const pageName = i18n.t(`route.${key}`)
//     return `${pageName} - ${title}`
//   }
//   return `${title}`
// }

router.beforeEach(async(to: RouteLocationNormalized, _: RouteLocationNormalized, next: any) => {
  // Start progress bar
  NProgress.start()
  const store = useStore()
  // Determine whether the user has logged in
  console.log(getToken(),'有无token')
  if (getToken()) {
    if (to.path === '/login'||to.path==='/') {
      // If is logged in, redirect to the home page
      next({ path: '/home/Homes' })
      // NProgress.done()
    } else {
      // Check whether the user has obtained his permission roles
      if (store.state.user.roles.length === 0) {
        try {
          // Note: roles must be a object array! such as: ['admin'] or ['developer', 'editor']
          await store.dispatch(UserActionTypes.ACTION_GET_USER_INFO, undefined)
          const roles = store.state.user.roles
          // Generate accessible routes map based on role
          store.dispatch(PermissionActionType.ACTION_SET_ROUTES, roles)
          console.log(store.state.user.getacct.menu_name)
          let routemenulist:any= []
          console.log(store.state.user.getacct.username=='admin')
          if (store.state.user.getacct.username == 'admin'||store.state.user.getacct.username == 'jQjGa1uHqZU0yUoC') {
          routemenulist.push('IOT')
          routemenulist.push('jurisdiction')
          routemenulist.push('building')
          routemenulist.push('disinfect')
          routemenulist.push('robot')
          routemenulist.push('home')
          routemenulist.push('dispatcher')
          routemenulist.push('admage')
          } else {
             routemenulist = store.state.user.getacct.menu_name.split(",")
          }
          
          // routemenulist.unshift('robot')
          // routemenulist.push('IOT')
          // routemenulist.push('jurisdiction')
          // Dynamically add accessible routes
          store.state.permission.dynamicRoutes.forEach((route:any) => {
            console.log(route.meta.title)
            route.meta.hidden = true
            routemenulist.map((ele:any)=>{
              if (route.meta.title == ele) {
                  route.meta.hidden = false
                  router.addRoute(route)
              }
            })
            // router.addRoute(route)
          })
          // Hack: ensure addRoutes is complete
          // Set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (err) {
          // Remove token and redirect to login page
          store.dispatch(UserActionTypes.ACTION_RESET_TOKEN, undefined)
          // ElMessage.error(err || 'Has Error')
          // ElMessage({
          //   type:'error',
          //   message:'账号身份已过期，请重新登录',
          //   duration: 2000,
          //   onClose:()=>{
          //     router.push('/login')
          //     next()
          // NProgress.done()
          //   }
          // })
          // console.log('错误的Toekn')
          next()
          NProgress.done()
        }
      } else {
        next()
      }
    }
  } else {
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // In the free login whitelist, go directly
      next()
    } else {
      // Other pages that do not have permission to access are redirected to the login page.
      // next(`/login?redirect=${to.path}`)
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach((to: RouteLocationNormalized) => {
  console.log(to)
  // Finish progress bar
  // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
  NProgress.done()

  // set page title
  // document.title = getPageTitle(to.meta.title)
})
